import type { Chord } from '@/types/chord';
import type { Move, MoveContext, MoveResult } from '../types';

/**
 * brighten the ending — Picardy third (minor i -> major I). Same root as
 * the original chord (i and I share scale degree 1), so unlike darken-it
 * this needs no root approximation — just a quality flip. The spec notes
 * it's "ideally the last chord" but applicable anywhere; ranking by
 * position is a palette-ordering concern for the UI task, not this
 * boolean-returning applicable().
 */
export const brightenTheEnding: Move = {
  id: 'brighten-the-ending',
  name: 'brighten the ending',
  theory: 'Picardy third',

  applicable(ctx: MoveContext): boolean {
    const chord = ctx.chords[ctx.index];
    return (
      !!chord &&
      ctx.mode === 'minor' &&
      chord.scaleDegree === 1 &&
      chord.quality === 'minor' &&
      !chord.isChromatic
    );
  },

  apply(ctx: MoveContext): MoveResult {
    const chord = ctx.chords[ctx.index];
    const changed: Chord = {
      ...chord,
      quality: 'major',
      isChromatic: true,
      chromaticType: 'borrowed',
      key: ctx.key,
      mode: ctx.mode,
    };
    const chords: Chord[] = ctx.chords.map((c, i) => (i === ctx.index ? changed : c));

    return {
      chords,
      changedIds: [changed.id],
      explanation: 'the last chord opens into major — light through the door.',
      theoryLabel: 'Picardy third · i → I',
    };
  },
};
